
import { QuestelServicesClient } from '@questelservices/common';
import store from '@/store';
import { FilingTypeDto,ChangeFilingTypeDto } from '@/models/FilingTypeDto';

export class FilingTypeService  {
  private client: QuestelServicesClient;

  constructor() {
    this.client = new QuestelServicesClient(store, "/api/filingtypes");
  }

  async getTypes() : Promise<FilingTypeDto[]> {
    return await this.client.get('/all');
  }

  async changeType(changeFileDto: ChangeFilingTypeDto) : Promise<any> {
    return await this.client.postJson('/change',changeFileDto);
  }
}